import { Platform } from '@angular/cdk/platform';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { DateFormat } from 'src/app/core/class/date-format';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-view-properties-dialog',
  styleUrls: ['./view-properties-dialog.component.scss'],
  templateUrl: './view-properties-dialog.component.html',
  providers: [
    // DateFormat,
    { provide: MAT_DATE_LOCALE, useValue: 'vi' },
    {
      provide: DateAdapter,
      useClass: DateFormat,
      deps: [MAT_DATE_LOCALE, Platform],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class ViewPropertiesDialogComponent implements OnInit {
  listDataSource: any[] = [];
  customerMohaId: any = null
  customerMohaName: any = null
  listCustomer: any[] = [];
  optionsMap = new Map<number, any[]>();
  displayedColumns = ["stt", "nameCriteria", "infoTemplate"];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ViewPropertiesDialogComponent>,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
    this.listDataSource = this.data.listDataSource
    this.customerMohaId = this.data.customerMohaId
    this.customerMohaName = this.data.customerMohaName
    this.listCustomer = this.data.listCustomer
    this.optionsMap = this.data.optionsMap
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
